export enum Thickness {
  horizontal = 'horizontal',
  diagonal = 'diagonal',
}

export const ThicknessLabel = {
  horizontal: 'Горизонтальное',
  diagonal: 'Диагональное',
};
